import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// styles
import styles from './PdpRespTitle.scss';

// helpers
import get from 'lodash.get';

export function PdpRespTitle({ item }) {
    let artCreator = null;
    let artCreationDate = null;
    let itemTitle = get(item, 'title');

    if (item.isArt) {
        itemTitle = <span className={styles.artTitle}>{itemTitle}</span>;

        // artCreationDate
        const creationDate = get(item, 'classification.creationDate');
        if (creationDate) {
            artCreationDate = <p>{creationDate}</p>;
        }

        // artCreator
        const { displayName, name } = get(item, 'creators[0].creator') || {};
        const creatorName = displayName || name;
        if (creatorName) {
            artCreator = creatorName;
        }
    }

    return (
        <h1 className={styles.wrapper}>
            {artCreator}
            <div className={styles.title} data-tn="pdp-main-title">
                {itemTitle}
                {artCreationDate}
            </div>
        </h1>
    );
}

PdpRespTitle.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpRespTitle, {
    item: graphql`
        fragment PdpRespTitle_item on Item {
            title
            isArt
            vertical
            creators {
                creator {
                    name
                    displayName
                    publishedItemsCount
                }
            }
            classification {
                creationDate
            }
        }
    `,
});
